import { action, API, controller } from "api";
import { useAppContext } from "context";

import { useNavigate } from "react-router-dom";
import { lsDelete } from "./Method";

const useLogout = () => {
  const { setAuthUser, setBizContext } = useAppContext();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await API(controller.Auth + action.Logout).get();
      setAuthUser(null); // clear auth state
      lsDelete("bizContext"); // remove business context
      navigate("/auth"); // redirect
      setBizContext({});
    } catch (error) {
      console.error("Logout failed:", error);
      navigate("/auth"); // fallback redirect
    }
  };

  return logout;
};

export default useLogout;
